import { render } from "./InputMessage.vue?vue&type=template&id=8d2f7c9c&scoped=true&ts=true"
import script from "./InputMessage.vue?vue&type=script&lang=ts"
export * from "./InputMessage.vue?vue&type=script&lang=ts"

import "./InputMessage.vue?vue&type=style&index=0&id=8d2f7c9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d2f7c9c"]])

export default __exports__